/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsLocaleStringListItem
 */
export interface MelcoModelsLocaleStringListItem {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLocaleStringListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLocaleStringListItem
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLocaleStringListItem
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLocaleStringListItem
     */
    module?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLocaleStringListItem
     */
    text?: string | null;
}

export function MelcoModelsLocaleStringListItemFromJSON(json: any): MelcoModelsLocaleStringListItem {
    return MelcoModelsLocaleStringListItemFromJSONTyped(json, false);
}

export function MelcoModelsLocaleStringListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsLocaleStringListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'module': !exists(json, 'module') ? undefined : json['module'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function MelcoModelsLocaleStringListItemToJSON(value?: MelcoModelsLocaleStringListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'key': value.key,
        'source': value.source,
        'module': value.module,
        'text': value.text,
    };
}


